/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-left-sk': {
    width: 4,
    height: 6,
    viewBox: '0 0 4 6',
    data: `
        <path d="M0.642853 2.29172L3.55831 5.20717L2.94092 5.82456L0.0254625 2.90911L0.642853 2.29172Z" fill="white"/>
        <path d="M0.0254625 2.90911L2.94092 -0.00634763L3.55831 0.611043L0.642853 3.5265L0.0254625 2.90911Z" fill="white"/>
    `
  }
})